//
// IMPORTANT: This file is a schema and must be managed with extreme care.
// See types/schema/README.md for more information.
//

import type { AccountDetailsConfig } from './account-details'
import type { AccountListConfig } from './account-list'
import type { AllocationListConfig } from './allocation-list'
import type { FilterListConfig } from './filter-list'
import type { HoldingListConfig } from './holding-list'
import type { ModelBuilderConfig } from './model-builder'
import type { ModelDetailsConfig } from './model-details'
import type { ModelListConfig } from './model-list'
import type { ProposalBuilderConfig } from './proposal-builder'
import type { ProposalsConfig } from './proposals'
import type { TradeBlotterConfig } from './trade-blotter'
import type { TradeDeskTradeBlotterConfig } from './trade-desk-trade-blotter'
import type { UserProfileConfig } from './user-profile'

export type PageConfig = PageConfigMap[Page]

export enum Page {
  FilterList = 'filter-list',
  TradeBlotter = 'trade-blotter',
  TradeDeskTradeBlotter = 'trade-desk-trade-blotter',
  HistoricalOrders = 'historical-orders',
  AccountList = 'account-list',
  AccountDetails = 'account-details',
  AllocationList = 'allocation-list',
  BondDetails = 'bond-details',
  ModelList = 'model-list',
  ModelDetails = 'model-details',
  ModelBuilder = 'model-builder',
  Proposals = 'proposals',
  ProposalBuilder = 'proposal-builder',
  SleeveManagement = 'sleeve-management',
  HoldingList = 'holding-list',
  ExecutionRules = 'execution-rules',
  UserProfile = 'user-profile',
}

export type PageConfigMap = {
  [Page.FilterList]: FilterListConfig
  [Page.TradeBlotter]: TradeBlotterConfig
  [Page.TradeDeskTradeBlotter]: TradeDeskTradeBlotterConfig
  // biome-ignore lint/complexity/noBannedTypes: Bulk suppression as part of biome migration
  [Page.HistoricalOrders]: {} // No config for now
  [Page.AccountList]: AccountListConfig
  [Page.AccountDetails]: AccountDetailsConfig
  [Page.AllocationList]: AllocationListConfig
  // biome-ignore lint/complexity/noBannedTypes: Bulk suppression as part of biome migration
  [Page.BondDetails]: {}
  [Page.ModelList]: ModelListConfig
  [Page.ModelDetails]: ModelDetailsConfig
  [Page.ModelBuilder]: ModelBuilderConfig
  [Page.Proposals]: ProposalsConfig
  [Page.ProposalBuilder]: ProposalBuilderConfig
  // biome-ignore lint/complexity/noBannedTypes: Bulk suppression as part of biome migration
  [Page.SleeveManagement]: {}
  [Page.HoldingList]: HoldingListConfig
  // biome-ignore lint/complexity/noBannedTypes: Bulk suppression as part of biome migration
  [Page.ExecutionRules]: {} // No config for now
  [Page.UserProfile]: UserProfileConfig
}
